var prev_scrolltop = null;
var is_animated = false;
function aboutJump() {
	if (location.href.indexOf('/about') != -1 && location.hash) {
		$('section').show();
		var pos = $(location.hash).offset().top-$('nav').height()-32;

		if (pos < 100)
			pos = 0;

		$('.menu').hide();
		$('.menu-bg').hide();
		
		$('html,body').scrollTop(pos)
	}	
}

function collision($div1, $div2) {
	var x1 = $div1.offset().left;
	var y1 = $div1.offset().top;
	var h1 = $div1.outerHeight(true);
	var w1 = $div1.outerWidth(true);
	var b1 = y1 + h1;
	var r1 = x1 + w1;
	var x2 = $div2.offset().left;
	var y2 = $div2.offset().top;
	var h2 = $div2.outerHeight(true);
	var w2 = $div2.outerWidth(true);
	var b2 = y2 + h2;
	var r2 = x2 + w2;

	if (b1 < y2 || y1 > b2 || r1 < x2 || x1 > r2) return false;
	return true;
}

function doSortItemList() {
	if ($('body').data('class') == 'Programs') {
		var parent = $('ul.item-list'), cont = parent.children('li');

		cont.detach().sort(function(a, b) {
			var astts = $(a).data('date');
			var bstts = $(b).data('date')
			return (astts > bstts) ? (astts > bstts) ? 1 : 0 : -1;
		});

		parent.append(cont);
		var cnt = 0;
		$('ul.item-list li').each(function() {
			if (cnt)
				$(this).removeClass('gap').addClass('gap');
			else
				$(this).removeClass('gap');
			cnt++;
		})
	}
}

function preloadAudio() {
	if ($('.audio-player').size()) {
		$('.audio-player').each(function() {
			var id = $('audio',this).attr('id');
			initAudio (id)
		});
	}
}

function initFullscreenBox() {
	var html = '';
	html += '<div class="fullscreen">';
	html += '<div id="btn-close"><i class="fa fa-times-circle" aria-hidden="true"></i></div>';
	html += '<div class="holder"></div>';
	html += '</div>';

	$('body').append (html);
}

function loadFullscreenBox(obj) {
	var img = obj.attr('src');

	if (obj.data('file')) {
		if (obj.data('file').indexOf('youtube') != -1) {
			var youtube_id = obj.data('file').replace ('https://www.youtube.com/watch?v=','');
			$('.fullscreen .holder').html ('<iframe width="100%" height="100%" src="https://www.youtube.com/embed/'+youtube_id+'" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');
		} else {
			$('.fullscreen .holder').css({'background-image':'url("'+img+'")'});				
		}
	} else {

		$('.fullscreen .holder').css({'background-image':'url("'+img+'")'});	
	}

	$('.fullscreen').fadeIn('fast');
	$('html').css('overflow','hidden'); 
}

function menuPosition() {
	if ($('.menu').outerHeight(true) < $(window).height()) {     
		$('.menu').addClass('fixed');
	} else {
		$('.menu').removeClass('fixed');
	}
}

function footerRelocation() {
	if ($('footer').position().top < $(window).height()) {        
		$('footer').addClass('bottom');         
	}

	if ($('.breaker').offset().top > $('footer').position().top) {
		$('footer').removeClass();   
	}  
}

function removeEmptyItems() {
	if ($('.item-list li').size() == 0) {
		$('.item-list').remove();
	}
}


function doItemize() {
	if ($('body[data-class="Publishing"] .titles').size()) {
		var max_col;

		if (window.matchMedia("(min-width: 1024px)").matches) {
			max_col = 3;
		} else if (window.matchMedia("(min-width: 768px)").matches) {
			max_col = 2;        
		} else {
			max_col = 1;
		}

		$cnt = 0;
		$('.divider').remove();
		$('body[data-class="Publishing"] .titles .item').each (function (index) { 
			$cnt++;
			if ($cnt == max_col) {
				$(this).after('<li class="divider"></li>');
				$cnt = 0;
			}
		});
	}
}

function DoDigitalCatalogDivider() {
	if ($('ul.digital-catalog').size()) {
		var max_col;

		if (window.matchMedia("(min-width: 1024px)").matches) {
			max_col = 3;
		} else if (window.matchMedia("(min-width: 768px)").matches) {
			max_col = 2;        
		} else {
			max_col = 1;
		}

		$cnt = 0;
		$('.divider').remove();
		$('ul.digital-catalog li').each (function (index) { 
			$cnt++;
			if ($cnt == max_col) {
				$(this).after('<li class="divider"></li>');
				$cnt = 0;
			}
		});
	}
}

function DoSocialMedia() {
	if ($('.social-media').size()) {
		var title = $('h2').text();
		var url = location.href;
		$('#share-email').attr('href','mailto:?subject='+title+'&body='+url);

		$('#share-facebook').attr('href','https://www.facebook.com/sharer/sharer.php?u='+url);
		$('#share-twitter').attr('href','http://twitter.com/share?text=&url='+url);
	}
}

function DoHomeFeaturedShelf() {
	if (window.matchMedia("(max-width: 576px)").matches) {
		$('.home-bg-featured-shelves').each(function() {
			$('article ul',$(this)).width(250*3);			
		//	$('article',$(this)).append('<div class="spacer"></div>');
	})
	} else {
		$('.home-bg-featured-shelves').each(function() {
			$('article ul',$(this)).removeAttr('style');
		//	$('.spacer').remove();
	})
	}
}

function DoLibraryFeaturedShelf() {
	if (window.matchMedia("(max-width: 576px)").matches) {
		$('.feature-shelves li').each(function() {
			$('article section ul',$(this)).width(250*3);			
		//	$('article section',$(this)).append('<div class="spacer"></div>');
	})
	} else {
		$('.feature-shelves li').each(function() {
			$('article section ul',$(this)).removeAttr('style');
		//	$('.spacer').remove();
	})
	}
}

$(document).ready(function(){
	initFullscreenBox ();
	doItemize ();
	removeEmptyItems();
	DoDigitalCatalogDivider();
	preloadAudio();

	$('#mc-embedded-cancel').on('click',function() {
		$('#mc_embed_signup').fadeOut('fast');
	})

	$('.join-our-mailing-list').on('click',function() {
		$('#mc_embed_signup').fadeIn('fast');
	})
	$('nav, nav a').on('click',function (e) {
		e.stopPropagation(); //stop the propagation   
		if ($(this).attr('class') == 'btn-search') {
			if ($('.search').css('display') == 'none') {
				prev_scrolltop = $('html,body').scrollTop();
				$('html,body').scrollTop(0);
				$('section').hide();
			} else {
				$('html,body').scrollTop(prev_scrolltop);
				$('section').show();
			}		
			
			$('.menu').hide();
			$('.menu-bg').hide();
			$('.search').toggle();
		} else if ($(this).attr('class') == 'home-link') {
			location.href = "/";
		} else {
			if ($('.menu').css('display') == 'none') {
				prev_scrolltop = $('html,body').scrollTop();
				$('html,body').scrollTop(0);
				$('section').hide();
			} else {
				$('html,body').scrollTop(prev_scrolltop);
				$('section').show();
			}
			$('.search').hide();
			$('.menu').toggle();
			$('.menu-bg').toggle();
			menuPosition();		
		}
	})

	$('.paypal-options .selected').on('click', function() {
		var parent = $(this).parent();
		if ($('ul',parent).css('display') == 'block')
			$('ul',parent).hide();
		else {
			$('ul',parent).css({left:$(this).position().left,top:$(this).position().top+$(this).height(),width:$(this).width()});
			$('ul',parent).show();

		}
	})
	$('.paypal-options ul li').on('click', function() {
		var parent = $(this).parent().parent();
		$('.selected',parent).html($(this).html());
		$(this).parent().hide();
		$('input[name="os0"]',parent).val($(this).data('value'))
	});

	$('.result-list li').on('click',function() {
		location.href = $(this).data('url');
	})

	$('.past-list li article,.item-list li article,.items li article').on('click',function() {
		if ($(this).data('url'))
			location.href = $(this).data('url');	
	})

	$('.lightbox').on('click', function() {
		loadFullscreenBox($(this));
	})

	$('.back-to-top').on('click', function() {
		$(window).scrollTop(0);
	});

	$('.fullscreen').on('click',function() {
		$('.fullscreen').fadeOut('fast',function() {
			$('html').removeAttr('style');
		});
	})

	$(window).on('hashchange', function() {
		aboutJump();
	});

	$(window).scroll(function () {
		var scroll = $(window).scrollTop();
		if (!is_animated) {
			is_animated = true;     

			if (scroll == 0) {
				$('.back-to-top').fadeOut('fast', function () {is_animated = false})
			} else {

				$('.back-to-top').fadeIn('fast', function () {is_animated = false});

			}                      
		}               
	}); 

	$(window).resize(function() {
		footerRelocation();
		doItemize ();
		DoDigitalCatalogDivider();
		DoHomeFeaturedShelf();
		DoLibraryFeaturedShelf();
	});
});

$(window).load(function() {
	aboutJump();
	footerRelocation();
	DoSocialMedia();
	DoHomeFeaturedShelf();
	DoLibraryFeaturedShelf();
	doSortItemList();
});

